import React from "react";
import { Container, Typography, Box } from "@mui/material";

const TermsOfService = () => {
  return (
    <Container maxWidth="md" style={{ paddingTop: 80, paddingBottom: 40 }}>
      <Box>
        <Typography variant="h3" gutterBottom align="center" style={{ marginBottom: 40 }}>
          Terms of Service
        </Typography>
        <Typography variant="body1" paragraph style={{ marginBottom: 32 }}>
          Welcome to Costing Wizard! Use of this website and application is subject to the terms below. Please read these terms carefully before using the service.
        </Typography>
        <Typography variant="h5" gutterBottom style={{ marginTop: 32, marginBottom: 12 }}>1. Acceptance of Terms</Typography>
        <Typography variant="body1" paragraph style={{ marginBottom: 32 }}>
          By using the website or app, you agree to these terms. If you do not agree, please do not use the service.
        </Typography>
        <Typography variant="h5" gutterBottom style={{ marginTop: 32, marginBottom: 12 }}>2. Privacy and Data Security</Typography>
        <Typography variant="body1" paragraph style={{ marginBottom: 32 }}>
          We are committed to protecting your privacy according to our privacy policy. However, we cannot guarantee absolute security of your data.
        </Typography>
        <Typography variant="h5" gutterBottom style={{ marginTop: 32, marginBottom: 12 }}>3. User Responsibility</Typography>
        <Typography variant="body1" paragraph style={{ marginBottom: 32 }}>
          The user is solely responsible for reviewing any quote, calculation, or document generated by the app before providing it to a client. Calculation errors, bugs, or inaccuracies may occur. Do not rely on the results without independent verification.
        </Typography>
        <Typography variant="h5" gutterBottom style={{ marginTop: 32, marginBottom: 12 }}>4. Bugs, Errors, and Service Availability</Typography>
        <Typography variant="body1" paragraph style={{ marginBottom: 32 }}>
          The app is provided as-is (AS IS). Bugs, errors, or service interruptions may occur. We strive to improve and fix issues, but do not guarantee full availability or flawless operation.
        </Typography>
        <Typography variant="h5" gutterBottom style={{ marginTop: 32, marginBottom: 12 }}>5. Data Storage and Backup</Typography>
        <Typography variant="body1" paragraph style={{ marginBottom: 32 }}>
          We back up data in the cloud, but are not responsible for any data loss. It is recommended to export and back up important data independently.
        </Typography>
        <Typography variant="h5" gutterBottom style={{ marginTop: 32, marginBottom: 12 }}>6. Commercial Use and Limitation of Liability</Typography>
        <Typography variant="body1" paragraph style={{ marginBottom: 32 }}>
          Use of the app is at your own risk. We are not liable for any direct or indirect, financial or other damages resulting from use of the service.
        </Typography>
        <Typography variant="h5" gutterBottom style={{ marginTop: 32, marginBottom: 12 }}>7. Changes to Terms</Typography>
        <Typography variant="body1" paragraph style={{ marginBottom: 32 }}>
          We may update these terms from time to time. Continued use of the service constitutes acceptance of the updated terms.
        </Typography>
        <Typography variant="body2" color="textSecondary" align="center" style={{ marginTop: 48 }}>
          Last updated: June 2024
        </Typography>
      </Box>
    </Container>
  );
};

export default TermsOfService; 